var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationBellOffOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 19v-2h2v-7c0-.55.07-1.092.213-1.625A6.086 6.086 0 016.85 6.85l1.5 1.5a4.174 4.174 0 00-.262.812A4.01 4.01 0 008 10v7h6.2L1.4 4.2l1.4-1.4 18.4 18.4-1.4 1.4-3.65-3.6H4zm14-3.85l-2-2V10c0-1.1-.392-2.042-1.175-2.825C14.042 6.392 13.1 6 12 6c-.45 0-.87.071-1.262.213A4.148 4.148 0 009.65 6.8L8.2 5.35c.333-.25.692-.48 1.075-.688A4.836 4.836 0 0110.5 4.2v-.7c0-.417.146-.77.438-1.062A1.444 1.444 0 0112 2c.417 0 .77.146 1.062.438.292.291.438.645.438 1.062v.7a5.927 5.927 0 013.225 2.087C17.575 7.346 18 8.583 18 10v5.15zM12 22c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0110 20h4a1.93 1.93 0 01-.587 1.413A1.928 1.928 0 0112 22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBellOffOutline);
export default __webpack_public_path__ + "83c8e4b71498423dda083f0b6be2dfa5.svg";
export { ForwardRef as ReactComponent };